import { render, staticRenderFns } from "./DetailPerintah.vue?vue&type=template&id=243c9a73&"
import script from "./DetailPerintah.vue?vue&type=script&lang=js&"
export * from "./DetailPerintah.vue?vue&type=script&lang=js&"
import style0 from "./DetailPerintah.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports